import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MonacoEditorModule } from '@y42/monaco-editor';
import { GitHistoryDialogModule } from '../git-history-dialog/git-history-dialog.module';
import { GitFileEditorComponent } from './git-file-editor.component';

@NgModule({
  declarations: [GitFileEditorComponent],
  imports: [
    CommonModule,
    GitHistoryDialogModule,
    MatButtonModule,
    FontAwesomeModule,
    MatTooltipModule,
    MonacoEditorModule,
  ],
  exports: [GitFileEditorComponent],
})
export class GitFileEditorModule {}
